export enum LabeledAvoidanceLevel {
    Contraindicated = 1,
    Avoid = 2,
}
